// eslint-disable-next-line no-underscore-dangle
export default Object.assign({}, process.env, window._env_);
